//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import wx from "weixin-js-sdk";
import wx from "weixin-jsapi";
export default {
  data() {
    return {
      prepay_id: "",
      payData: {},
    };
  },
  mounted() {
    console.log(wx);
    this.$axios
      .post("https://api.hfbsoftware.com/member/test/getSignInfo", {
        url: location.href.split("#")[0],
      })
      .then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data;
          console.log(data);
          wx.config({
            debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appid, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
            console.log("chenggong");
          });
        }
      });
  },
  methods: {
    zhifu() {
      this.$axios
        .post("https://api.hfbsoftware.com/member/test/getPay")
        .then((res) => {
          if (res.data.code === 200) {
            const data = res.data.data;
            wx.chooseWXPay({
              appId: data.appId,
              timestamp: data.timeStamp,
              nonceStr: data.nonceStr,
              package: data.package,
              signType: data.signType,
              paySign: data.paySign,
              success: function (res) {},
            });
          }
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/demo.vue